import { ComponentType, Suspense, ReactNode } from 'react'

export function withSuspense<P extends object>(
  Component: ComponentType<P>,
  fallback: ReactNode
): ComponentType<P> {
  return (props: P) => (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  )
}
